import { render } from "./BoardTopDeleteModal.vue?vue&type=template&id=58b7dff6&scoped=true"
import script from "./BoardTopDeleteModal.vue?vue&type=script&lang=js"
export * from "./BoardTopDeleteModal.vue?vue&type=script&lang=js"

import "./BoardTopDeleteModal.vue?vue&type=style&index=0&id=58b7dff6&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-58b7dff6"

export default script